import "../styles/featureComparison.css"

function FeatureComparison() {

    return (
        <div className="featureComparisonContainer">
            <div className="premiumTier">
                <h2>Premium Features</h2>
                <ul>
                    <li id="free">Free Default Hitter Ratings Plus:</li>
                    <li className="bullet">Hitter and Pitcher Trends*</li>
                    <li className="example">Example: Pete Crow-Armstrong Has Recorded a Hit 70% of the Time When He Has an Elite Rating</li>
                    <br />
                    <li className="bullet">In-Depth Pitch Reports</li>
                    <li className="example">Pitch usage and hitter stats based on handedness</li>
                    <li className="example">Example: Tarik Skubal throwing his sinker nearly 50% to left-handed hitters and Kyle Schwarber is hitting .392 vs sinkers from left-handed pitchers.</li>
                    <br />
                    <li className="bullet">Pitcher Ratings*</li>
                    <li className="bullet">Matchup Builder: View Ratings for Matchups of Your Choice</li>
                    <li className="bullet">Current Season Hitter Ratings (Available in May Once Enough Data)</li>
                    <li className="bullet">Percent Change in Matchup Stats on Hitter Ratings Table*</li>
                    <li className="bullet">Team Total and Moneyline Trends*</li>
                    
                    <li className="bullet">Home and Away Splits on Hitter and Pitcher Pages*</li>
                    
                    <br />
                    <li style={{listStyle: "none"}}>*Current Season & Default Datasets</li>
                </ul>
            </div>
        </div>
    )
}

export default FeatureComparison